"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var INFO_BEHAVIOUR_ON_HOVER = {
  APPEARS: 'APPEARS',
  DISAPPEARS: 'DISAPPEARS',
  NO_CHANGE: 'NO_CHANGE'
};
var _default = INFO_BEHAVIOUR_ON_HOVER;
exports["default"] = _default;